import { Chip, Icon, TextEllipsis } from '@aibees/shared/components';
import { capitalize, classnames } from '@aibees/shared/utils';
import { Avatar, Box, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { OfficeLocationCardProps as Props } from './types';

export const OfficeLocationCard = memo(
  ({ className, item, hoveredItem }: Props) => {
    const { isHeadquarter, key, name, value, office, offices, flag } = item;

    return (
      <Styled.Wrapper
        className={classnames('OfficeLocationCard', className)}
        sx={SX.root(Boolean(hoveredItem && hoveredItem === item.key))}
        gap={1.5}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          gap={1}
        >
          <Stack direction="row" alignItems="center" gap={1}>
            <Avatar size={22} variant="rounded" src={flag} />
            <Typography variant="body3" fontWeight={700} color="grey.700">
              {name}
            </Typography>
          </Stack>
          {isHeadquarter && (
            <Chip
              label="HQ"
              color="default"
              variant="outlined"
              shape="rounded"
              size="xsmall"
            />
          )}
        </Stack>
        {office && (
          <Stack direction="row" gap={0.5}>
            <Box>
              <Icon name="location" color="grey.500" size={20} />
            </Box>
            <TextEllipsis variant="body4" fontWeight={700} color="grey.500">
              {capitalize(office)}
            </TextEllipsis>
          </Stack>
        )}
        {offices && (
          <Stack>
            {offices.map((i, index) => (
              <Box key={i} sx={SX.companyInfo}>
                <Styled.BranchSvg
                  src={
                    index === 0
                      ? '/assets/images/branch-2.svg'
                      : '/assets/images/branch.svg'
                  }
                />

                <Box>
                  <Icon name="location" color="grey.500" size={20} />
                </Box>

                <TextEllipsis variant="body4" fontWeight={300} color="grey.500">
                  {capitalize(i)}
                </TextEllipsis>
              </Box>
            ))}
          </Stack>
        )}
      </Styled.Wrapper>
    );
  }
);

OfficeLocationCard.displayName = 'OfficeLocationCard';
